// Colors
export const colors = {
  black: '#000000',
  buttonBorder: '#696969',
  buttonHover: '#a0a0a0',
  chipToggle: '#a3a3a3',
  completionBg: 'rgba(46, 175, 152, 0.06)',
  compliant: '#a8df6d',
  dirtyWhite: '#ede9e8',
  error: '#ff0000',
  grey: '#808080',
  info: '#FFFF7D',
  major: '#FF7B7B',
  minor: '#FED354',
  noEntitiesText: 'rgba(32, 21, 71, 0.5)',
  paper: '#f6f6f6',
  selected: '#c8c8c8',
  stackBgGrey: '#d3d3d3',
  stackBgWhite: '#f5f5f5',
  textButtonHover: '#afafaf',
  wireBg: '#e2e2e2',
  wireButton: '#2EAF98',
  white: '#ffffff',
  mainGreen: '#2EAF98',
  chipGrey: '#2015474d',
  headerColor: '#201547',
  notApplicable: 'rgba(211, 47, 47, 0.08)',
};

// Load Status
export const LoadStatus = Object.freeze({
  INITIAL: 'init',
  IN_PROGRESS: 'inProgress',
  SUCCESS: 'success',
  FAILURE: 'failure',
});
